<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <control-card>
          <layout-no-padding slot="title">
            <page-title :routeProps="$store.state.global.pages.email"></page-title>
          </layout-no-padding>
          <template slot="options">
            <v-btn icon flat color="primary" @click="selectFile()">
              <v-icon>attach_file</v-icon>
            </v-btn>
            <v-btn icon flat color="grey" class="mr-0" @click="drawer = !drawer">
              <v-icon>playlist_add</v-icon>
            </v-btn>
            <input type="file" ref="fileSelector" style="display:none" @change="onFileSelected" />
          </template>

          <template slot="content">
            <v-form ref="form" style="width: 100%">
              <layout-no-padding>
                <v-flex md4>
                  <div class="flex-container-space-between" style="align-items: center;">
                    <v-text-field
                      label="To"
                      prepend-icon="supervised_user_circle"
                      v-model="addTo"
                      @keyup.enter="addAddress(addTo)"
                    ></v-text-field>
                    <v-btn
                      class="ml-2"
                      flat
                      icon
                      @click="addAddress(addTo)"
                      :color="$store.state.global.pages.email.color"
                    >
                      <v-icon>chevron_right</v-icon>
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex md8>
                  <v-text-field
                    label="* Subject"
                    prepend-icon="supervised_user_circle"
                    v-model="subject"
                    ref="subject"
                    :rules="subjectRules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-alert :value="true" color="grey lighten-4" icon="supervised_user_circle">
                    <v-chip
                      v-for="(address, i) in filteredTo"
                      :key="i"
                      close
                      @input="removeAddress(address)"
                      small
                    >
                      <v-avatar
                        size="10"
                        class="primary white--text"
                      >{{address.charAt(0).toUpperCase()}}</v-avatar>
                      {{address}}
                    </v-chip>
                    <div v-if="to.length > 0" class="flex-container-space-between pt-4">
                      <v-btn flat color="grey" @click="to = []">Clear All</v-btn>
                      <v-chip
                        v-if="to.length > 20"
                        small
                        @click="showAllEmails = !showAllEmails"
                      >{{!showAllEmails ? 'See '+ (to.length - 20) + ' more...' : 'See less...'}}</v-chip>
                    </div>
                    <v-progress-linear
                      v-if="loadingEmails"
                      indeterminate
                      height="4"
                      :color="$store.state.global.pages.email.color"
                    ></v-progress-linear>
                  </v-alert>
                </v-flex>
                <v-flex xs12>
                  <v-alert :value="true" color="grey lighten-4" icon="attach_file">
                    <v-chip
                      v-for="(file, i) in files"
                      :key="i"
                      close
                      @input="removeFile(file)"
                      small
                    >
                      <v-avatar size="10" class="grey lighten-1">
                        <v-icon>attach_file</v-icon>
                      </v-avatar>
                      {{file.name}}
                    </v-chip>
                  </v-alert>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    box
                    name="input-7-4"
                    label="* Content"
                    v-model="content"
                    ref="content"
                    :rules="contentRules"
                  ></v-textarea>
                </v-flex>
              </layout-no-padding>
            </v-form>
          </template>
          <template slot="actions">
            <div class="flex-container-space-between">
              <div></div>
              <v-btn color="primary" :loading="loading" depressed @click="send()">Send</v-btn>
            </div>
          </template>
        </control-card>
      </v-flex>
      <!-- <email-control></email-control>
      <tipping-view></tipping-view>-->
    </v-layout>
    <filter-drawer permanent @addToEmail="fetchEmails()"></filter-drawer>
  </v-container>
</template>

<script>
// import EmailControl from './components/emailControl'
// import TippingView from './components/emailView'
import Api from "@/services/api";
import Rules from "@/services/validation/rules/rules";
import FilterDrawer from "@/components/trips/filterDrawer";
import Store from "@/store/computed/storeHelpers";
export default {
  components: {
    FilterDrawer
  },
  data() {
    return {
      addTo: "",
      to: [],
      subject: "",
      content: "",
      files: [],
      loading: false,
      loadingEmails: false,
      showAllEmails: false,
      subjectRules: [
        v => Rules.isRequired(v),
        v => Rules.minLength(v, 4),
        v => Rules.maxLength(v, 100)
      ],
      contentRules: [
        v => Rules.isRequired(v),
        v => Rules.minLength(v, 4),
        v => Rules.maxLength(v, 3000)
      ]
    };
  },
  computed: {
    billingPeriod: Store.getSet({ store: "shared", prop: "billingPeriod" }),
    projectId: Store.getSet({ store: "shared", prop: "projectId" }),
    siteId: Store.getSet({ store: "shared", prop: "siteId" }),
    drawer: Store.getSet({ store: "shared", prop: "drawer" }),
    filteredTo() {
      if (!this.showAllEmails) return this.to.slice(0, 20);
      return this.to;
    }
  },
  mounted() {
    this.drawer = true;
  },
  beforeDestroy() {
    this.drawer = false;
  },
  methods: {
    selectFile() {
      this.$refs.fileSelector.click();
    },
    onFileSelected() {
      this.files.push(this.$refs.fileSelector.files[0]);
      this.$refs.fileSelector.value = null;
    },
    addAddress(address) {
      if (this.to.indexOf(address) > -1) return;
      if (!address) return;
      this.to.unshift(address);
      this.addTo = "";
    },

    removeAddress(address) {
      var i = this.to.indexOf(address);
      if (i > -1) this.to.splice(i, 1);
    },
    removeFile(file) {
      var i = this.files.indexOf(file);
      if (i > -1) this.files.splice(i, 1);
    },
    send() {
      if (!this.to.length || !this.$refs.form.validate())
        return this.snack({
          text: "Please correct form errors!",
          color: "red"
        });
      var formData = new FormData();
      this.to.forEach(address => {
        formData.append("to[]", address);
      });
      this.files.forEach(file => {
        formData.append("files[]", file);
      });
      formData.append("subject", this.subject);
      formData.append("content", this.content);
      console.log("SENDING EMAIL");
      this.loading = true;
      Api.post("email", formData)
        .then(result => {
          console.log(result);
          this.resetForm();
          this.loading = false;
          this.snack({ text: "Email Sent!", color: "green" });
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.snack({ text: err.response.data.message, color: "red" });
        });
    },
    resetForm() {
      this.to = [];
      this.files = [];
      this.subject = "";
      this.content = "";
      this.$refs.form.resetValidation();
    },
    fetchEmails() {
      this.loadingEmails = true;
      var payload = {
        projectId: this.projectId,
        siteId: this.siteId,
        billingPeriod: this.billingPeriod
      };
      Api.post("email/fetchEmails", payload)
        .then(result => {
          result.data.result.forEach(address => {
            this.addAddress(address);
          });
          this.loadingEmails = false;
        })
        .catch(err => {
          console.log(err);
          this.loadingEmails = false;
        });
    }
  }
};
</script>

<style scoped>
.v-alert {
  border-radius: 5px !important;
  border: none !important;
}
.v-chip .v-avatar {
  height: 24px !important;
  width: 24px !important;
}
</style>

